export const EXPRESS_CHECKOUT_PAYMENT_METHOD_WARNING =
  'Apple Pay / Google Payでの決済を選択すると、今後すべてのサブスクリプションの支払いが、今回選択の決済方法に更新されます。';
